import { authorizedRDRequestsv2 } from "../httpRequest";

export interface StupidBaseResponse {
  '$id': string;
  '$type': string;
}
export interface InitPaymentResponse extends StupidBaseResponse{
  WalletToken:string;
  WalletUri: string;
  Mode: number;
}
const walletApiRequest = {
  initiatePayment: async ():Promise<InitPaymentResponse> => {
    const response = await authorizedRDRequestsv2.post<InitPaymentResponse>(
      `webaccesswallet/init-wallet-payment`,
      {}
    );
    return response;
  },
  getGoogleWalletPassUrl: async (confirmationNumber: number): Promise<any> => {
    return authorizedRDRequestsv2.get(`webaccesswallet/google-wallet-pass-url?confirmationNumber=${confirmationNumber}`);
  },
  downloadAppleWalletPass: async (confirmationNumber: number, membershipId?: number): Promise<void> => {
    const params = new URLSearchParams({ confirmationNumber: confirmationNumber.toString() });
    if (membershipId) params.append('membershipId', membershipId.toString());
    const response = await authorizedRDRequestsv2.getBlob(`webaccesswallet/apple-wallet-pass?${params.toString()}`);
    const url = window.URL.createObjectURL(response);
    const link = document.createElement('a');
    link.href = url;
    link.download = membershipId ? `pass-${membershipId}.pkpass` : 'pass.pkpass';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
  getCustomerAccountCredit: async (): Promise<number> => {
    const response = await authorizedRDRequestsv2.get<number>(
      `webaccesswallet/customer-account-credit`
    );
    return response;
  },
};

export default walletApiRequest;
